import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShieldCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.583 8.107L7.087 9.611L10.31 6.389M13.512 7.978C13.512 9.541 12.958 11.054 11.949 12.248C10.94 13.442 9.541 14.24 8 14.5C6.459 14.24 5.06 13.442 4.051 12.248C3.042 11.054 2.488 9.541 2.488 7.978V3.477L8 1.5L13.512 3.477V7.978Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgShieldCheck;
